import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs';
import {AccountOffice } from '../../../../models/pukal-reports.model';


@Component({
    selector: 'dialog-federal-edit-account',
    templateUrl: 'dialog.editaccount.html',
    styleUrls: ['dialog.editaccount.css']
})
export class EditAccountFederalGovernmentPukalDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    isSubmit: boolean = false;
    errorMessage: string = '';
    editaccform: FormGroup;
    warrantdepartment: string = '';
    warrantptj: string = '';
    pukalnumber: string = '';
    screenCode: string = '';
    selectedagencyCode: any;
    selectedaccoff: any;
    selectedaccoffCode: any;
    selectedaccnumber: any;
    selectedobject: any;
    selectedactivation: any;
    ptjaddress: any;
    vote: any;
    chargedeparment: any;
    changeptj: any;
    vpa: any;
    vpss: any;
    cp: any;
    accSts: any;
    userId: any;
    fileSts: any;
    creationDate: any;
    activationDate: any;
    lastModifiedDate: any;
    terminationDate: any;
    createdUserId: any;
    objects = [];
    loading: boolean = true;
    accOffices$: Observable<AccountOffice[]>;
    warrant_auth_code: string = 'JA';

    constructor(public dialogRef: MatDialogRef<EditAccountFederalGovernmentPukalDialog>,
        @Inject(MAT_DIALOG_DATA) public accData: any,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar
    ) { }  

    ngOnInit() {
        this.accOffices$ = this.managePukalService.getAccountOffices(this.warrant_auth_code);
        this.screenCode = this.accData.screenCode;
        this.selectedagencyCode = this.accData.selectedAcc.Airline_Agency_Code;
        this.selectedaccoffCode = this.accData.selectedAcc.Acc_Off_Code;
        this.selectedaccnumber = this.accData.selectedAcc.Acc_No;

        this.editaccform = new FormGroup({
            selectedagency: new FormControl({ value: '', disabled: true }),
            selectedaccoffCode: new FormControl({ value: '', disabled: false }, Validators.required),
            selectedaccoff: new FormControl({ value: '', disabled: true }),
            ptjaddress: new FormControl({ value: '', disabled: false }, Validators.required),
            pukalnumber: new FormControl({ value: '', disabled: true }),
            warrantdepartment: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
            warrantptj: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(6)]),
            vote: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5)]),
            chargedeparment: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
            changeptj: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(6)]),
            vpa: new FormControl({ value: '', disabled: false }, Validators.maxLength(9)),
            vpss: new FormControl({ value: '', disabled: false }, Validators.maxLength(16)),
            cp: new FormControl({ value: '', disabled: false }, Validators.maxLength(1)),
            selectedobject: new FormControl({ value: '', disabled: false }, Validators.required),
            accSts: new FormControl({ value: '', disabled: true }),
            fileSts: new FormControl({ value: '', disabled: true })
        });

        let init_sub = this.managePukalService.initEditPukalAccountDetails(this.selectedagencyCode, this.selectedaccoffCode, this.selectedaccnumber)
            .subscribe(
                (data) => {
                    this.loading = false;
                    this.objects = data.TransObjects;
                    this.creationDate = data.Creation_Date;
                    this.activationDate = data.Activation_Date;
                    this.terminationDate = data.Termination_Date;
                    this.lastModifiedDate = data.Sys_Date;
                    this.createdUserId = data.Created_User_Id;
                    this.userId = data.User_Id;

                    this.editaccform.setValue({
                        selectedagency: data.Agency_Name,
                        selectedaccoff: data.Airline_Agency_Code,
                        ptjaddress: data.Acc,
                        pukalnumber: data.Acc_No,
                        warrantdepartment: data.Warrant_Dept,
                        warrantptj: data.Warrant_RCCC,
                        vote: data.Vote,
                        chargedeparment: data.Charge_Dept,
                        changeptj: data.Charge_RCCC,
                        vpa: data.Program,
                        vpss: data.Project,
                        cp: data.CP,
                        selectedobject: data.Object,
                        accSts: data.Acc_Sts,
                        fileSts: data.Rcd_Sts,
                        selectedaccoffCode : this.selectedaccoffCode
                    });
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");
        if (cfm) {
            this.isSubmit = true;
            
            let updatePukalAccount = {
                Acc: this.editaccform.get('ptjaddress')!.value,
                Warrant_Dept: this.editaccform.get('warrantdepartment')!.value,
                Warrant_RCCC: this.editaccform.get('warrantptj')!.value,
                Vote: this.editaccform.get('vote')!.value,
                Charge_Dept: this.editaccform.get('chargedeparment')!.value,
                Charge_RCCC: this.editaccform.get('changeptj')!.value,
                Program: this.editaccform.get('vpa')!.value,
                Project: this.editaccform.get('vpss')!.value,
                CP: this.editaccform.get('cp')!.value,
                Objects: this.editaccform.get('selectedobject')!.value,
                Airline_Agency_Code: this.selectedagencyCode,
                Acc_Off_Code: this.editaccform.get('selectedaccoffCode')!.value,
                Acc_No: this.selectedaccnumber,
            }

            let save_sub = this.managePukalService.updatePukalAccountDetails(updatePukalAccount)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            this.dialogRef.close('Edit successful');
                        } else {
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}